import React from 'react';
import {
  Box,
  Button,
  Container,
  Link,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';

interface NoAccessPageProps {
  onBackToLogin: () => void;
  title?: string;
  message?: string;
  primaryLabel?: string;
  showGroupsLink?: boolean;
}

const NoAccessPage: React.FC<NoAccessPageProps> = ({
  onBackToLogin,
  title = 'Ingen åtkomst',
  message = 'Du saknar rätt grupp. Kontakta admin.',
  primaryLabel = 'Försök igen',
  showGroupsLink = true,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.default,
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: '16px',
            background: theme.palette.background.paper,
            backdropFilter: 'blur(10px)',
          }}
        >
          <Box
            component="img"
            src="/Ictech_logotyp_svart.png"
            alt="ictech"
            sx={{
              height: 60,
              width: 'auto',
              display: 'block',
              mx: 'auto',
              mb: 3,
            }}
          />

          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              textAlign: 'center',
              color: theme.palette.text.primary,
              mb: 1,
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              textAlign: 'center',
              color: theme.palette.text.secondary,
              mb: 3,
            }}
          >
            {message}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
            <Button
              variant="contained"
              size="large"
              onClick={onBackToLogin}
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: '#fff',
                fontWeight: 600,
                py: 1.4,
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              {primaryLabel}
            </Button>

            {showGroupsLink && (
              <Button
                component={Link}
                href="https://groups.google.com/a/ictech.se/my-groups"
                target="_blank"
                rel="noreferrer"
                variant="outlined"
                size="large"
                sx={{
                  fontWeight: 600,
                  py: 1.4,
                  borderRadius: '8px',
                  textDecoration: 'none',
                }}
              >
                Google Groups
              </Button>
            )}
          </Box>

          {showGroupsLink && (
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                textAlign: 'center',
                color: theme.palette.text.secondary,
                lineHeight: 1.6,
              }}
            >
              Kontakta admin vid behov.
            </Typography>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default NoAccessPage;
